<template>
  <div class="content">
    <div>
      <b-container>
        <transition name="scale" mode="out-in">
          <router-view></router-view>
        </transition>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content',
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .content {
    background-color: $dark-card;
  }
}
.content {
  grid-area: content;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  overflow: hidden;
  border-radius: 0.5rem;
  background-color: $light-card;
  &:has(> div > .container > .uptime-kuma-dashboard), 
  &:has(> div > .container > .esxi-server-dashboard), 
  &:has(> div > .container > .ilo-server-dashboard), 
  &:has(> div > .container > .ipmi-server-dashboard) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    > div {
      > .container {
        height: 100%;
        max-width: 100%;
        padding: 0.25rem;
      }
    }
  }
  > div {
    height: 100%;
    overflow: auto;
  }
}
.scale {
  &-enter-active,&-leave-active {
    transition: all 0.5s ease;
  }
  &-enter-from,&-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>